import * as request from '@/utils/request'

export default {
  /**
   * 列表
   * @param data
   * @returns {Promise}
   */
  artistPicTextRecordList(data) {
    return request.post('/artist_pic_text_record/list', data)
  },
  /**
   * 详情
   * @param id
   * @returns {Promise}
   */
  artistPicTextRecordInfo(id) {
    return request.post('/artist_pic_text_record/info', { id: id })
  },
  /**
   * 添加
   * @param data
   * @returns {Promise}
   */
  artistPicTextRecordCreate(data) {
    return request.post('/artist_pic_text_record/create', data)
  },
  /**
   * 修改
   * @param data
   * @returns {Promise}
   */
  artistPicTextRecordUpdate(data) {
    return request.post('/artist_pic_text_record/update', data)
  },
  /**
   * 删除
   * @param id
   * @returns {Promise}
   */
  artistPicTextRecordDel(id) {
    return request.post('/artist_pic_text_record/delete', { id: id })
  },
  /**
   * 批量删除
   * @param ids
   * @returns {Promise}
   */
  artistPicTextRecordBatchDel(ids) {
    return request.post('/artist_pic_text_record/batch_delete', { ids: ids })
  },
  /**
   * @description 导出红人图文记录列表|下载导入模板
   * @param {*} data
   * @returns
   */
  artistPicTextRecordExportList(data) {
    return request.postBlob('/artist_pic_text_record/download',data)
  },
}
